import { useWeb3React } from "@web3-react/core"
import useRewardFarmer from "hooks/game/useRewardFarmer"
import Image from "next/image"
import { useEffect, useMemo } from "react"
import { injected } from "@hfc/shared/config/web3/connectors"
import Button, { LinkButton } from "@hfc/shared/components/Button"
import useFarmers from "hooks/useFarmers"
import useFarmGirls from "hooks/useFarmGirls"
import { FarmerI } from "@hfc/shared/typings/game/Farmer"
import Link from "next/link"
interface Props {
	shouldHideOverlay?: boolean
}

const Profile = ({ shouldHideOverlay }: Props) => {
	const {
		active: hasConnectedMetamask,
		chainId,
		library,
		activate,
		// deactivate,
		account,
	} = useWeb3React()

	const signer = useMemo(
		() => library?.getSigner() ?? null,
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[hasConnectedMetamask, account, chainId],
	)

	const { isLoadingPotatoBalance, potatoBalance } = useRewardFarmer(
		account,
		signer,
	)

	const { farmers, isLoading: isLoadingFarmer } = useFarmers(
		account?.toLowerCase() ?? null,
		signer,
	)
	const {
		farmGirls,
		isLoading: isLoadingFarmGirls,
		stakedFarmGirlIds,
	} = useFarmGirls(account?.toLowerCase() ?? null, signer)

	const connectMetamask = async () => {
		try {
			await activate(injected, (err) => {
				throw err
			})
		} catch (err) {
			console.error(err)
		}
	}

	const fallbackImage =
		"https://gateway.pinata.cloud/ipfs/QmQwxgMESwerK2y6gaYH65cRiNtiQhSZuYFNQd5f9P3pi6"

	// Temporarily set first farmer as profile
	const userFarmer: FarmerI & any = farmers?.[0]

	useEffect(() => {
		if (!hasConnectedMetamask) connectMetamask()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasConnectedMetamask])

	return (
		<div
			id="profile"
			className={`fixed z-10 p-3 rounded md:p-5 fixed-overlay bg-farm-black bg-opacity-90 text-center ${
				shouldHideOverlay ? "invisible" : ""
			}`}
		>
			<h2 className="hidden mb-2 text-lg text-center text-farm-yellow md:block">
				Howdy, Farmer!
			</h2>

			{hasConnectedMetamask ? (
				<div className="flex flex-row items-center justify-center w-full text-center md:flex-col">
					<div className="relative w-16 h-16 md:w-24 md:h-24">
						<Link href={`/profiles/${account}`}>
							<Image
								alt="profile"
								layout="fill"
								src={userFarmer?.image ?? fallbackImage}
								className="rounded-full cursor-pointer bg-farm-yellow"
								priority={true}
							/>
						</Link>
					</div>
					<LinkButton
						variant="primary"
						className="hidden w-full px-2 py-1 mx-2 mt-0 text-sm text-center md:mx-auto md:mt-2 md:block"
						href={`/profiles/${account}`}
					>
						{account?.substring(0, 8)?.toLowerCase() ?? ""}
					</LinkButton>
					<div className="mx-2 mt-0 text-center text-white text-md md:text-lg md:mx-auto md:mt-2 whitespace-nowrap ">
						🥔 {isLoadingPotatoBalance ? "..." : potatoBalance ?? 0}
					</div>

					<div className="flex mx-2 mt-0 text-center text-white text-md md:text-lg md:mx-auto md:mt-2 whitespace-nowrap">
						<div>
							👨‍🌾 {isLoadingFarmer ? "..." : farmers?.length ?? 0}
						</div>
						<div className="ml-2">
							👩‍🌾{" "}
							{isLoadingFarmGirls
								? "..."
								: farmGirls?.length ?? 0}
						</div>
					</div>
				</div>
			) : (
				<Button
					onClick={connectMetamask}
					variant="secondary"
					className="block w-full px-2 py-1 mx-auto"
				>
					{/* Desktop */}
					Connect
				</Button>
			)}
		</div>
	)
}

export default Profile
